var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg2AppliedCouponGraphic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 254.427,
    height: 140.401,
    viewBox: "0 0 254.427 140.401",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6422",
    "data-name": "Group 6422",
    transform: "translate(-53.961 -142.216)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1081",
    "data-name": "Rectangle 1081",
    d: "M7.5,7.457,4.271,9.282,0,1.885,3.2,0Z",
    transform: "translate(83.909 164.3)",
    fill: "#32d8b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38772",
    "data-name": "Path 38772",
    d: "M-4615.026,1869.5l2.253-6.324,2.816,6.324-2.816,5.222Z",
    transform: "translate(4668.987 -1661.176)",
    fill: "#fcea06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38773",
    "data-name": "Path 38773",
    d: "M-4615.026,1869.5l2.253-6.324,2.816,6.324-2.816,5.222Z",
    transform: "translate(4892.492 -1661.176)",
    fill: "#fcea06",
    opacity: 0.83
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6354",
    "data-name": "Group 6354",
    transform: "translate(138.414 174.293)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_669",
    "data-name": "Ellipse 669",
    cx: 1.299,
    cy: 1.299,
    r: 1.299,
    transform: "translate(5.63)",
    fill: "#fbf4be"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_670",
    "data-name": "Ellipse 670",
    cx: 1.299,
    cy: 1.299,
    r: 1.299,
    transform: "translate(7.795 4.764)",
    fill: "#fbf4be"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_675",
    "data-name": "Ellipse 675",
    cx: 1.299,
    cy: 1.299,
    r: 1.299,
    transform: "translate(12.558 2.598)",
    fill: "#fbf4be"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_674",
    "data-name": "Ellipse 674",
    cx: 1.299,
    cy: 1.299,
    r: 1.299,
    transform: "translate(3.031 6.929)",
    fill: "#fbf4be"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_676",
    "data-name": "Ellipse 676",
    cx: 1.299,
    cy: 1.299,
    r: 1.299,
    transform: "translate(5.197 12.125)",
    fill: "#fbf4be"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_679",
    "data-name": "Ellipse 679",
    cx: 1.299,
    cy: 1.299,
    r: 1.299,
    transform: "translate(7.362 16.889)",
    fill: "#fbf4be"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_680",
    "data-name": "Ellipse 680",
    cx: 1.299,
    cy: 1.299,
    r: 1.299,
    transform: "translate(16.889 12.125)",
    fill: "#fbf4be"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_678",
    "data-name": "Ellipse 678",
    cx: 1.299,
    cy: 1.299,
    r: 1.299,
    transform: "translate(0 14.291)",
    fill: "#fbf4be"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_677",
    "data-name": "Ellipse 677",
    cx: 1.299,
    cy: 1.299,
    r: 1.299,
    transform: "translate(15.157 7.362)",
    fill: "#fbf4be"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_671",
    "data-name": "Ellipse 671",
    cx: 1.299,
    cy: 1.299,
    r: 1.299,
    transform: "translate(10.393 9.527)",
    fill: "#fbf4be"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_672",
    "data-name": "Ellipse 672",
    cx: 1.299,
    cy: 1.299,
    r: 1.299,
    transform: "translate(12.558 14.724)",
    fill: "#fbf4be"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_673",
    "data-name": "Ellipse 673",
    cx: 1.299,
    cy: 1.299,
    r: 1.299,
    transform: "translate(14.291 19.92)",
    fill: "#fbf4be"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6355",
    "data-name": "Group 6355",
    transform: "translate(153.545 195.284) rotate(-90)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1073",
    "data-name": "Rectangle 1073",
    width: 28.928,
    height: 53.84,
    rx: 2,
    transform: "translate(15.741 0) rotate(17)",
    fill: "#b3dcd6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6300",
    "data-name": "Group 6300",
    transform: "translate(37.073 0) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3603",
    "data-name": "Path 3603",
    d: "M0,0H28.129V12.421l-2.305,1.308,2.305,2.547V51.811H0V17.13l1.716-3.4L0,12.421Z",
    transform: "translate(53.074 1.306) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6297",
    "data-name": "Group 6297",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6286",
    "data-name": "Group 6286",
    transform: "translate(38.115 8.167)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6285",
    "data-name": "Group 6285"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3597",
    "data-name": "Path 3597",
    d: "M.851,0A.851.851,0,0,0,0,.851V2.666a.851.851,0,0,0,1.7,0V.851A.851.851,0,0,0,.851,0Z",
    fill: "#42a998"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6288",
    "data-name": "Group 6288",
    transform: "translate(38.115 13.613)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6287",
    "data-name": "Group 6287"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3598",
    "data-name": "Path 3598",
    d: "M.851,0A.851.851,0,0,0,0,.851V2.666a.851.851,0,0,0,1.7,0V.851A.851.851,0,0,0,.851,0Z",
    fill: "#42a998"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6290",
    "data-name": "Group 6290",
    transform: "translate(38.115 19.057)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6289",
    "data-name": "Group 6289",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3599",
    "data-name": "Path 3599",
    d: "M.851,0A.851.851,0,0,0,0,.851V2.666a.851.851,0,1,0,1.7,0V.851A.851.851,0,0,0,.851,0Z",
    fill: "#42a998"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6298",
    "data-name": "Group 6298"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6283",
    "data-name": "Group 6283"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3596",
    "data-name": "Path 3596",
    d: "M52.578,0h-11.8a.851.851,0,0,0-.851.851v.907a.964.964,0,1,1-1.929,0V.851A.851.851,0,0,0,37.151,0H1.758A1.76,1.76,0,0,0,0,1.758V28.983a1.76,1.76,0,0,0,1.758,1.758H37.151A.851.851,0,0,0,38,29.891v-.907a.964.964,0,0,1,1.929,0v.907a.851.851,0,0,0,.851.851h11.8a1.76,1.76,0,0,0,1.758-1.758V1.758A1.761,1.761,0,0,0,52.578,0Zm.057,28.983a.057.057,0,0,1-.057.057H41.632v-.057a2.67,2.67,0,0,0-1.815-2.526v-1.1a.851.851,0,0,0-1.7,0v1.1A2.67,2.67,0,0,0,36.3,28.983v.057H1.758a.057.057,0,0,1-.057-.057V1.758A.057.057,0,0,1,1.758,1.7H36.3v.057a2.67,2.67,0,0,0,1.815,2.526v1.1a.851.851,0,1,0,1.7,0v-1.1a2.67,2.67,0,0,0,1.815-2.526V1.7H52.578a.057.057,0,0,1,.057.057V28.983Z",
    fill: "#42a998"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6297-2",
    "data-name": "Group 6297",
    transform: "translate(15.659 10.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_104_",
    d: "M5.507.228a2.958,2.958,0,0,1-4.179,0,.778.778,0,0,0-1.1,1.1A4.5,4.5,0,0,0,3.417,2.646,4.5,4.5,0,0,0,6.606,1.328a.778.778,0,0,0-1.1-1.1Z",
    transform: "translate(0.938 7.175)",
    fill: "#42a998"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_105_",
    d: "M1.77,1.77A1.036,1.036,0,0,0,1.77.3,1.037,1.037,0,0,0,0,1.037a1.037,1.037,0,0,0,1.77.733Z",
    transform: "translate(0)",
    fill: "#42a998"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_106_",
    d: "M1.037,0A1.037,1.037,0,0,0,0,1.037a1.037,1.037,0,0,0,1.77.733A1.036,1.036,0,0,0,1.77.3,1.045,1.045,0,0,0,1.037,0Z",
    transform: "translate(6.636)",
    fill: "#42a998"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6356",
    "data-name": "Group 6356",
    transform: "translate(202.223 148.685)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_681",
    "data-name": "Ellipse 681",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#ea8f92",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.237,
    cy: 1.237,
    r: 1.237,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.237,
    cy: 1.237,
    r: 0.987,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_682",
    "data-name": "Ellipse 682",
    cx: 0.9,
    cy: 0.9,
    r: 0.9,
    transform: "translate(5.399 1.8)",
    fill: "#46d6cc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6304",
    "data-name": "Group 6304",
    transform: "translate(2.474 5.736)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_232",
    "data-name": "Line 232",
    x2: 1.35,
    y2: 2.249,
    transform: "translate(0.337)",
    fill: "none",
    stroke: "#f7e171",
    strokeLinecap: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_233",
    "data-name": "Line 233",
    y1: 1.35,
    x2: 2.137,
    transform: "translate(0 0.45)",
    fill: "none",
    stroke: "#f7e171",
    strokeLinecap: "round",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "spiral-svgrepo-com",
    transform: "matrix(0.996, -0.087, 0.087, 0.996, 157.901, 192.616)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6306",
    "data-name": "Group 6306",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3604",
    "data-name": "Path 3604",
    d: "M8.13,2.777a3.08,3.08,0,0,0-4.356,0,2.545,2.545,0,0,0,0,3.6,2.117,2.117,0,0,0,2.995,0,1.776,1.776,0,0,0,0-2.511,1.5,1.5,0,0,0-2.124,0,.408.408,0,1,0,.576.577.688.688,0,0,1,.972,0,.961.961,0,0,1,0,1.359,1.3,1.3,0,0,1-1.842,0,1.73,1.73,0,0,1,0-2.447,2.265,2.265,0,0,1,3.2,0,2.934,2.934,0,0,1,0,4.148,3.768,3.768,0,0,1-5.329,0A4.812,4.812,0,0,1,2.224.7.408.408,0,0,0,1.648.119a5.627,5.627,0,0,0,0,7.958,4.583,4.583,0,0,0,6.482,0A3.749,3.749,0,0,0,8.13,2.777Z",
    transform: "translate(0 0)",
    fill: "#dedeee"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "spiral-svgrepo-com-2",
    "data-name": "spiral-svgrepo-com",
    transform: "translate(218.025 171.323) rotate(-156)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6306-2",
    "data-name": "Group 6306",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3604-2",
    "data-name": "Path 3604",
    d: "M6.562,2.241a2.486,2.486,0,0,0-3.516,0,2.054,2.054,0,0,0,0,2.905,1.709,1.709,0,0,0,2.417,0,1.433,1.433,0,0,0,0-2.027,1.213,1.213,0,0,0-1.714,0,.329.329,0,1,0,.465.465.555.555,0,0,1,.784,0,.776.776,0,0,1,0,1.1,1.051,1.051,0,0,1-1.487,0,1.4,1.4,0,0,1,0-1.975,1.828,1.828,0,0,1,2.585,0,2.368,2.368,0,0,1,0,3.348,3.041,3.041,0,0,1-4.3,0A3.884,3.884,0,0,1,1.8.562.329.329,0,0,0,1.33.1a4.542,4.542,0,0,0,0,6.423,3.7,3.7,0,0,0,5.231,0A3.026,3.026,0,0,0,6.562,2.241Z",
    transform: "translate(0 0)",
    fill: "#dedeee"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_585",
    "data-name": "Ellipse 585",
    cx: 3.671,
    cy: 3.671,
    r: 3.671,
    transform: "translate(232.546 157.876)",
    fill: "#ff6584"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_587",
    "data-name": "Ellipse 587",
    cx: 3.671,
    cy: 3.671,
    r: 3.671,
    transform: "translate(53.961 252.392)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_589",
    "data-name": "Ellipse 589",
    cx: 3.671,
    cy: 3.671,
    r: 3.671,
    transform: "translate(275.812 275.274)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3592",
    "data-name": "Path 3592",
    d: "M735.7,368.369a19.387,19.387,0,0,1-8.863-15.234c-.043-.865-.173-1.861.544-2.495a1.607,1.607,0,0,1,2-.16,2.105,2.105,0,0,1-1.788,3.649c-2.293-.244-3.479-2.507-4.444-4.323-2.2-4.138-4.858-8.255-8.881-10.833-3.722-2.385-8.7-3.18-12.705-1.035-.7.375-.072,1.435.626,1.062,3.975-2.127,8.936-.919,12.386,1.678a22.619,22.619,0,0,1,5.152,5.706c.729,1.106,1.4,2.253,2.025,3.418a21.911,21.911,0,0,0,2,3.328c1.322,1.662,3.623,2.874,5.726,1.92a3.382,3.382,0,0,0,.873-5.359,2.892,2.892,0,0,0-4.636,1.353,8.437,8.437,0,0,0-.014,3.26,20.621,20.621,0,0,0,9.4,15.14C735.769,369.866,736.368,368.788,735.7,368.369Z",
    transform: "translate(-647.288 -148.077)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3075",
    "data-name": "Path 3075",
    d: "M44.743,15.247A19.387,19.387,0,0,1,29.579,6.265c-.459-.734-1.058-1.54-.741-2.444A1.607,1.607,0,0,1,30.5,2.709a2.106,2.106,0,0,1,.218,4.058c-2.121.9-4.26-.493-5.988-1.609C20.8,2.616,16.468.317,11.7.027,7.286-.241,2.554,1.489.1,5.316c-.429.669.637,1.288,1.064.622C3.6,2.143,8.519.78,12.8,1.366a22.616,22.616,0,0,1,7.279,2.471c1.176.61,2.317,1.287,3.434,2a21.915,21.915,0,0,0,3.368,1.931c1.964.807,4.564.744,5.936-1.114a3.382,3.382,0,0,0-1.85-5.105,2.893,2.893,0,0,0-3.388,3.441,8.439,8.439,0,0,0,1.577,2.853,20.621,20.621,0,0,0,15.59,8.637c.793.039.791-1.193,0-1.232Z",
    transform: "translate(223.367 217.785) rotate(-69)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6358",
    "data-name": "Group 6358",
    transform: "translate(4562.673 -3605.896)",
    opacity: 0.83
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3605",
    "data-name": "Path 3605",
    d: "M-4502.483,3755.164c-2.424-.173-5.278-3.8-5.278-3.8l2.752-2.752a7.874,7.874,0,0,0,5.483,3.65",
    fill: "#febc20",
    stroke: "#febc20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3606",
    "data-name": "Path 3606",
    d: "M-4489.394,3759.094l-2.94,2.907",
    transform: "translate(-10.132 -6.837)",
    fill: "#febc20",
    stroke: "#febc20",
    strokeLinecap: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6359",
    "data-name": "Group 6359",
    transform: "matrix(0.309, -0.951, 0.951, 0.309, -1872.555, -5239.062)",
    opacity: 0.83
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3605-2",
    "data-name": "Path 3605",
    d: "M-4502.483,3755.164c-2.424-.173-5.278-3.8-5.278-3.8l2.752-2.752a7.874,7.874,0,0,0,5.483,3.65",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3606-2",
    "data-name": "Path 3606",
    d: "M-4489.394,3759.094l-2.94,2.907",
    transform: "translate(-10.132 -6.837)",
    fill: "#6c63ff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2AppliedCouponGraphic);
export default __webpack_public_path__ + "static/media/2_Applied_coupon_graphic.9a14f6f2865ade8736653c48b85db3b1.svg";
export { ForwardRef as ReactComponent };